import { UserAboutMe } from 'graphql.generated';

import { Dropdown, Label } from '@blueprint/ui';

const options: Record<string, string> = {
    first_time_buyer: 'I am a first-time buyer',
    buyer_not_first_time: 'I am a buyer (not first-time)',
    property_to_sell: 'I have a property to sell',
    property_to_let: 'I have a property to let',
    offer_on_own_property: 'I have an offer on my property',
    recently_sold: 'I have recently sold',
    looking_to_invest: 'I am an investor/hoping to invest',
    looking_to_rent: 'I am looking to rent',
    curious_having_a_look: 'I am interested in property',
    agent: 'I am an agent',
    other: 'Other'
};

interface AboutYouProps {
    dropDownRef?: () => void;
}

export const AboutYou = ({ dropDownRef }: AboutYouProps) => {
    return (
        <>
            <Label htmlFor="situation-dropdown">
                What can Zoopla help you with?
            </Label>
            <Dropdown
                name="situation"
                id="situation-dropdown"
                ref={dropDownRef}
                data-testid="situation-dropdown"
            >
                <option value="">Select an option</option>
                {Object.values(UserAboutMe)
                    .filter((statusKey) => statusKey !== UserAboutMe.Other)
                    .map((statusKey) => (
                        <option
                            value={statusKey}
                            key={`situation-${statusKey}`}
                        >
                            {options[statusKey]}
                        </option>
                    ))}
                <option value={UserAboutMe.Other}>Other</option>
            </Dropdown>
        </>
    );
};
